import axios from "axios";
import Carousel from "../../misc/Carousel";
import { useEffect, useState } from "react";
import VideoPlayer from "../../misc/Video";

const Marca = () => {
  const [videoOne, setVideoOne] = useState("");
  const [videoTwo, setVideoTwo] = useState("");
  const [carouselOneImages, setCarouselOneImages] = useState<any>([]);
  const [carouselTwoImages, setCarouselTwoImages] = useState<any>([]);

  const addImageToCarousel = (newImageUrl: any) => {
    setCarouselOneImages((prevImages: any) => [...prevImages, newImageUrl]);
  };

  const addImageToCarouselTwo = (newImageUrl: any) => {
    setCarouselTwoImages((prevImages: any) => [...prevImages, newImageUrl]);
  };

  const getSignedUrl = async (key: string): Promise<string> => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/s3/signed-url?key=${encodeURIComponent(key)}`,
      { headers: { "auth-token": sessionStorage.getItem("token") } }
    );
    return data.url;
  };

  const getCarouselOne = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/publicidad/carouselOne`
      );

      const tempImageOne = response.data.filter(
        (image: any) => image.placement === "CarouselOnePictureOne"
      );
      const tempImageTwo = response.data.filter(
        (image: any) => image.placement === "CarouselOnePictureTwo"
      );
      const tempImageThree = response.data.filter(
        (image: any) => image.placement === "CarouselOnePictureThree"
      );
      const tempImageFour = response.data.filter(
        (image: any) => image.placement === "CarouselOnePictureFour"
      );
      const tempImageFive = response.data.filter(
        (image: any) => image.placement === "CarouselOnePictureFive"
      );

      for (const img of [tempImageOne, tempImageTwo, tempImageThree, tempImageFour, tempImageFive]) {
        if (img[0]?.link) {
          try {
            const url = await getSignedUrl(img[0].link);
            addImageToCarousel({ image: url, external_url: img[0].external_url });
          } catch (err) { console.error(err); }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCarouselTwo = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/publicidad/carouselTwo`
      );

      const tempImageOne = response.data.filter(
        (image: any) => image.placement === "CarouselTwoPictureOne"
      );
      const tempImageTwo = response.data.filter(
        (image: any) => image.placement === "CarouselTwoPictureTwo"
      );
      const tempImageThree = response.data.filter(
        (image: any) => image.placement === "CarouselTwoPictureThree"
      );
      const tempImageFour = response.data.filter(
        (image: any) => image.placement === "CarouselTwoPictureFour"
      );
      const tempImageFive = response.data.filter(
        (image: any) => image.placement === "CarouselTwoPictureFive"
      );

      for (const img of [tempImageOne, tempImageTwo, tempImageThree, tempImageFour, tempImageFive]) {
        if (img[0]?.link) {
          try {
            const url = await getSignedUrl(img[0].link);
            addImageToCarouselTwo({ image: url, external_url: img[0].external_url });
          } catch (err) { console.error(err); }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getVideos = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/publicidad/videos`,
        {
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${sessionStorage.getItem("token")}`,
          },
        }
      );

      const tempVideoOne = response.data.filter(
        (image: any) => image.placement === "VideoOne"
      );
      const tempVideoTwo = response.data.filter(
        (image: any) => image.placement === "VideoTwo"
      );

      if (tempVideoOne.length > 0) {
        try {
          const url = await getSignedUrl(tempVideoOne[0].link);
          setVideoOne(url);
        } catch (err) { console.error(err); }
      }

      if (tempVideoTwo.length > 0) {
        try {
          const url = await getSignedUrl(tempVideoTwo[0].link);
          setVideoTwo(url);
        } catch (err) { console.error(err); }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCarouselTwo();
    getCarouselOne();
    getVideos();
  }, []);

  return (
    <div className="flex h-screen flex-col gap-6 overflow-auto px-4 pb-6">
      <Carousel images={carouselOneImages} />
      <VideoPlayer videoUrl={videoOne} />
      <Carousel images={carouselTwoImages} />
      <VideoPlayer videoUrl={videoTwo} />
    </div>
  );
};

export default Marca;
